// extracted by mini-css-extract-plugin
export default {"custom-select-padding":"ModalLicense_custom-select-padding__hHs3T"};